<template>
  <div class="steps" :class="{ mobile: isMobile() }">
    <div class="step step__1">
      <div class="step-square">
        <AssetV3 dir="icons" name="blue-calendar-with-dollar.svg"/>
      </div>
      <p class="step-description">Escolha o parcelamento e valor da entrada</p>
    </div>

    <div class="step-divisor step-divisor__1" />

    <div class="step step__2">
      <div class="step-square">
        <AssetV3 dir="icons" name="blue-face-recognition.svg"/>
      </div>
      <p class="step-description">Envie a foto do seu documento e uma selfie</p>
    </div>

    <div class="step-divisor step-divisor__2" />

    <div class="step step__3">
      <div class="step-square">
        <AssetV3 dir="icons" name="blue-follow-payments.svg"/>
      </div>
      <p class="step-description">Pronto! Acompanhe e pague suas parcelas</p>
    </div>
  </div>
</template>

<script>
import UtilMixin from '@/mixins/util';
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  name: 'checkout-user-info-display',
  mixins: [UtilMixin],
  components: {
    AssetV3,
  },
  props: {
    userInfo: {
      type: Object,
    },
    buttonText: {
      type: String,
      default: null,
    },
  },
  methods: {
    actionEvent(value) {
      this.$emit('updateData', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.steps {
  position: relative;
  display: grid;

  grid-template-columns: 4fr 1fr 4fr 1fr 4fr;
  grid-template-areas:
    'square1 divisor1 square2 divisor2 square3'
    'description description description description description';

  margin: 46px 0 48px 0;

  .step {
    &__1 {
      grid-area: square1;

      .step-square {
        &::before {
          @extend .step-square-circle;
          content: '1';
        }
      }
    }

    &__2 {
      grid-area: square2;

      .step-square {
        &::before {
          @extend .step-square-circle;
          content: '2';
        }
      }
    }

    &__3 {
      grid-area: square3;

      .step-square {
        &::before {
          @extend .step-square-circle;
          content: '3';
        }
      }
    }
  }

  .step-square {
    width: 40px;
    height: 40px;

    margin: 0 auto 9px auto;

    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;

    border: 1px solid var(--blue-200);
    border-radius: 8px;
    flex-shrink: 0;
  }

  .step-square-circle {
    @extend .small-bold;
    color: var(--white);

    position: absolute;
    top: 0;
    right: 100%;

    transform: translate(50%,-50%);

    width: 20px;
    height: 20px;

    border-radius: 50%;
    background-color: var(--blue-400);

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .step-description {
    @extend .small-semibold;
    color: var(--gray-700);

    text-align: center;
    flex-grow: 1;
  }

  .step-divisor {
    height: 1px;
    margin-top: 21px;

    position: absolute;
    left: -28px;
    top: 0;

    width: 83px;

    background: var(--blue-200);

    &__1 {
      grid-area: divisor1;
    }

    &__2 {
      grid-area: divisor2;
    }
  }

  &.mobile {
    display: flex;
    flex-direction: column;

    margin: 36px 0;

    .step {
      display: flex;
      gap: 12px;

      align-items: center;
    }

    .step-square {
      margin: 0 0 0 9px;
    }

    .step-description {
      font-size: 16px;
      line-height: 24px;

      text-align: left;
      font-weight: normal;
    }

    .step-divisor {
      height: 46px;
      width: 1px;

      position: static;

      margin: 0 0 0 30px;
    }
  }
}
</style>
